import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SellerDashboard from '../components/dashboard/SellerDashboard';
import BuyerDashboard from '../components/dashboard/BuyerDashboard';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import { Box, Typography, CircularProgress } from '@mui/material';

const Dashboard: React.FC = () => {
  const { isAdmin, isBuyer, isSeller, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  // Determine which dashboard to show based on user role
  if (isAdmin) {
    return <AdminDashboard />;
  } else if (isBuyer && isSeller) {
    // If user is both buyer and seller, show buyer dashboard by default
    // with an option to switch (could be implemented with tabs or toggle)
    return <BuyerDashboard />;
  } else if (isBuyer) {
    return <BuyerDashboard />;
  } else if (isSeller) {
    return <SellerDashboard />;
  } else {
    // Fallback for users without a specific role
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Typography variant="h5">
          Tu cuenta no tiene roles asignados. Por favor contacta a un administrador.
        </Typography>
      </Box>
    );
  }
};

export default Dashboard;
